import { WELL_REGEX } from '../utils/const'

export const checkCommaAndBackSlash = (value) => {
  if (value && (typeof value === "string" || value instanceof String)) {
    if (`${value}`.includes(",")) {
      return "Cannot contain commas";
    } else if (`${value}`.includes("/")) {
      return "Cannot contain slashes";
    } else if (`${value}`.includes("\\")) {
      return "Cannot contain backslashes";
    }
  }
  return undefined;
};

export const checkCommaAndBackSlashOnTags = (value) => {
  let res;
  let errorIndex = [];
  if (Array.isArray(value)) {
    errorIndex = value.filter((x) => !!checkCommaAndBackSlash(x));
    if (errorIndex.length > 0) {
      res = {
        errorIndex,
        message: "Tags cannot contain commas or slashes",
      };
    }
  }
  return res;
};

export const checkWellNumber = (value) => {
  return (WELL_REGEX.test(value) || value?.length === 0 || !value) ? undefined : "Well must be between A01 and H12";
}

export const validateUuid = (val) => {
  let currErrors = [];
  if (!val) {
    currErrors = [...currErrors, `UUID must be supplied and unique`];
  } else if (val.length < 4) {
    currErrors = [
      ...currErrors,
      "UUID must be at least 4 characters long.",
    ];
  }

  return currErrors;
};

export const validateName = (val) => {
  const BANNED_CHARACTERS = [";", ",", "."];
  // check for errors
  let currErrors = [];
  if (!val) {
    currErrors = [
      ...currErrors,
      "Name must be supplied."
    ];
  }
  if (val.length < 4) {
    currErrors = [
      ...currErrors,
      "Name must be at least 4 characters long.",
    ];
  }
  if (val.trim() !== val) {
    currErrors = [...currErrors, "Name cannot start or end with a space."];
  }
  BANNED_CHARACTERS.filter((ban) => val.includes(ban)).forEach((banned) => {
    currErrors = [...currErrors, `Name cannot include character ${banned}`];
  });

  return currErrors;
};

export const validateAddress = (val) => {
  // const BANNED_CHARACTERS = [";", ",", "."];
  // check for errors
  let currErrors = [];
  if (!val) {
    return ["Address must be supplied"];
  }
  if (val.length < 4) {
    currErrors = [
      ...currErrors,
      "Address must be at least 4 characters long.",
    ];
  }
  if (val.trim() !== val) {
    currErrors = [
      ...currErrors,
      "Address cannot start or end with a space.",
    ];
  }
  // BANNED_CHARACTERS.filter((ban) => val.includes(ban)).forEach((banned) => {
  //   currErrors = [
  //     ...currErrors,
  //     `Address cannot include character ${banned}`,
  //   ];
  // });

  return currErrors;
};

export const validateGps = (val) => {
  // check for errors
  let currErrors = [];
  if (!val || val.length < 1) {
    currErrors = [...currErrors, "You must specify a GPS"];
  } else {
    if (val.trim() !== val) {
      console.log("no space", `"${val.trim()}"`, `"${val}"`);
      currErrors = [...currErrors, "GPS cannot start or end with a space."];
    }
    const latlonarr = val.split(",").map((x) => parseFloat(x));
    if (
      Array.isArray(latlonarr) &&
      latlonarr.length === 2 &&
      !latlonarr.some((x) => isNaN(x) || x === null || x === undefined)
    ) {
      const [latitude, longitude] = latlonarr;
      if (latitude < -90 || latitude > 90) {
        currErrors = [...currErrors, "Latitude must be between -90 and 90"];
      }
      if (longitude < -180 || longitude > 180) {
        currErrors = [
          ...currErrors,
          "Longitude must be between -180 and 180",
        ];
      }
    } else {
      currErrors = [...currErrors, "GPS has invalid format"];
    }
  }

  return currErrors;
};